import {useState, useEffect, useMemo} from 'react';
import api from "../services/axiosInstance";
import { backendPort } from '../components/Fungsiku'; 
import { useGlobalOpsi } from "../components/GlobalOpsi";
import { useNotification } from './NotifPopup';

export function PageKonten24_Edit({
    idposisi,
    setIdPosisi,
    daftarBan, // data_ban lengkap
    setDaftarBan,
    dataMT,
    setDataMTState = () => {},
    authIdentity = {},
    daftarKodeBan,
    setDaftarKodeBan,
    isEditRecordDone = false,
    markSkipNextDaftarBanReload = () => {},
    }) {
  const TELAPAK_DEFAULT = 'Tidak Diketahui';
  const TELAPAK_ADD = '__ADD_TELAPAK__';
  const SPAKBOARD_DEFAULT = 'Normal';
  const SPAKBOARD_OPTIONS = [
    'Normal',
    'Rusak',
    'Tidak Ada'
  ];

  const { globalOpsi, manualResyncGlobalOpsi } = useGlobalOpsi();
  const opsiCabang = globalOpsi.opsiCabang;
  const opsiMerkBan = globalOpsi.opsiMerkBan;
  const opsiUkuran = globalOpsi.opsiUkuran;
  const opsiSuplierRaw = Array.isArray(globalOpsi?.opsiSuplier) ? globalOpsi.opsiSuplier : [];
  const opsiSuplier = Array.from(new Set(
    opsiSuplierRaw
      .map((x) => (typeof x === "string" ? x : String(x?.suplier || x?.nama_suplier || x?.supplier || "").trim()))
      .filter(Boolean)
  ));
  const opsiSuplierFinal = opsiSuplier.length ? opsiSuplier : [];
  const opsiBan = Array.isArray(globalOpsi?.opsiBan) ? globalOpsi.opsiBan : [];
  const parseTelapakList = (raw) => String(raw || '')
    .split('#')
    .map((x) => String(x || '').trim())
    .filter(Boolean);
  const buildTelapakBySuplier = (rows = []) => {
    const out = {};
    for (const row of rows) {
      const key = typeof row === 'string'
        ? String(row || '').trim()
        : String(row?.suplier || row?.nama_suplier || row?.supplier || '').trim();
      if (!key) continue;
      out[key] = parseTelapakList(row?.telapak);
    }
    return out;
  };
  const baseTelapakBySuplier = useMemo(() => {
    return buildTelapakBySuplier(opsiSuplierRaw);
  }, [opsiSuplierRaw]);
  const namaCabangAktifFallback = opsiCabang.find((x) => String(x?.kode_cabang || '').trim() === String(dataMT?.kode_cabang || '').trim())?.nama_cabang || '';
  
  const opsiStatus = [
        "NT","UT","VT-1","UV-1","Casing","Afkir"
      ]    
  const formatRibu = (value) => {
    if (value === null || value === undefined) return '0';
    return new Intl.NumberFormat('id-ID').format(Number(value)??0);
  };
  const formatYYYYMMDD = (date) => {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
      }; 
  const [td, setTD] = useState({td1 : 0, td2 : 0, td3 : 0, td4 : 0});
  const tahunSekarang = new Date().getFullYear();
  const opsiTahun = Array.from({ length: 50 }, (_, i) => tahunSekarang - i);
  const { showNotif } = useNotification();
  const actorNama = String(authIdentity?.nama || "").trim();
  const actorKodeCabang = String(authIdentity?.kode_cabang || "").trim();
  const isPusat = actorKodeCabang === 'C-1';
  const sanitizeSeriBanInput = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9-]/g, '');
  //const [loading, setLoading] = useState(false);
  const dataBanKosong = {
        id_ban : '',
        seri_ban  : `SMTR-${generateKode()}`,
        ukuran : '',
        merk : '',
        telapak: TELAPAK_DEFAULT,
        //id_event : '', //otomatis
        event : 'initial_otf',
        tanggal : dataMT.tanggal,
        kmt : 0,
        td : '',
        catatan_ban : '',
        place : `${dataMT.id_mt}#${idposisi}`,
        status : '',
        reff : {},
        id_suplier : '',
        user: actorNama,
        kode_cabang: dataMT.kode_cabang || actorKodeCabang || '',
      };  
  const [bisaSubmitEdit, setBisaSubmitEdit] = useState(true);    
  const [dataBan, setDataBan] = useState(dataBanKosong); 
  const kodeCabangAktif = String(dataBan?.kode_cabang || dataMT?.kode_cabang || actorKodeCabang || '').trim();
  const namaCabangAktif = opsiCabang.find((x) => String(x?.kode_cabang || '').trim() === kodeCabangAktif)?.nama_cabang
    || namaCabangAktifFallback
    || kodeCabangAktif;
  const [telapakBySuplier, setTelapakBySuplier] = useState(baseTelapakBySuplier);
  const [showTelapakModal, setShowTelapakModal] = useState(false);
  const [newTelapak, setNewTelapak] = useState('');
  const [savingTelapak, setSavingTelapak] = useState(false);
  const [kondisiSpakboard, setKondisiSpakboard] = useState(SPAKBOARD_DEFAULT);
  const [constraintLoading, setConstraintLoading] = useState(false);
  const [editConstraint, setEditConstraint] = useState({
    has_historical_event: false,
    lock_modal_except_merk_ukuran_catatan: false,
    disable_status: false,
    disable_supplier: false,
    disable_td: false,
    allow_td_bulk_sync: false,
  });
  const idBanTerpasang = useMemo(() => Number(daftarKodeBan?.[idposisi] || 0), [daftarKodeBan, idposisi]);
  const statusAksiBan = idBanTerpasang > 0 ? 'edit' : 'baru';
  const lockModalExceptMerkUkuranCatatan = statusAksiBan === 'edit'
    && (constraintLoading || Boolean(editConstraint?.lock_modal_except_merk_ukuran_catatan));
  const disableStatusField = statusAksiBan === 'edit'
    && (constraintLoading || lockModalExceptMerkUkuranCatatan || Boolean(editConstraint?.disable_status));
  const disableSupplierField = statusAksiBan === 'edit'
    && (constraintLoading || lockModalExceptMerkUkuranCatatan || Boolean(editConstraint?.disable_supplier));
  const disableTdField = statusAksiBan === 'edit'
    && (constraintLoading || lockModalExceptMerkUkuranCatatan || Boolean(editConstraint?.disable_td));
  const disableStatusByDoneFlow = Boolean(isEditRecordDone);
  const disableTdByDoneFlow = Boolean(isEditRecordDone);
  const showHistoricalWarning = false;
  const isCadanganPosisi = /^S-/i.test(String(idposisi || '').trim());
  const telapakOptions = useMemo(() => {
    const supplierKey = String(dataBan?.id_suplier || '').trim();
    const dynamic = Array.isArray(telapakBySuplier?.[supplierKey]) ? telapakBySuplier[supplierKey] : [];
    const unique = [...new Set(dynamic.map((x) => String(x || '').trim()).filter(Boolean))];
    return [TELAPAK_DEFAULT, ...unique, TELAPAK_ADD];
  }, [dataBan?.id_suplier, telapakBySuplier]);
  const close = ()=>{
    setIdPosisi('');
    setDataBan(dataBanKosong);
  };
  function generateKode(length = 8) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }

  useEffect(()=>{
    setTelapakBySuplier(baseTelapakBySuplier);
  }, [baseTelapakBySuplier]);

  useEffect(() => {
    if (isCadanganPosisi) {
      setKondisiSpakboard('');
      return;
    }
    let parsed = {};
    try {
      const raw = dataMT?.spakboard;
      parsed = typeof raw === 'string' ? (raw.trim() ? JSON.parse(raw) : {}) : (raw && typeof raw === 'object' ? raw : {});
    } catch {
      parsed = {};
    }
    const savedValue = String(parsed?.[idposisi] || '').trim();
    setKondisiSpakboard(SPAKBOARD_OPTIONS.includes(savedValue) ? savedValue : SPAKBOARD_DEFAULT);
  }, [dataMT?.spakboard, idposisi, isCadanganPosisi]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await api.get(`${backendPort}/api/master/daftar_suplier`);
        if (cancelled) return;
        const rows = Array.isArray(res?.data) ? res.data : [];
        const latestMap = buildTelapakBySuplier(rows);
        if (Object.keys(latestMap).length > 0) {
          setTelapakBySuplier(latestMap);
        }
      } catch (err) {
        if (!cancelled) console.error(err);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    let cancelled = false;
    setDataBan({
      ...dataBanKosong,
      id_ban: idBanTerpasang > 0 ? idBanTerpasang : '',
      place: `${dataMT.id_mt}#${idposisi}`,
      tanggal: dataMT.tanggal,
      user: actorNama,
    });
    setTD({ td1: 0, td2: 0, td3: 0, td4: 0 });

    const applyBanDetail = (row = null) => {
      const banProfilRow = row || ((Array.isArray(opsiBan) ? opsiBan : [])
        .find((x) => Number(x?.id_ban || 0) === Number(idBanTerpasang || 0)) || null);
      if (!banProfilRow || cancelled) return false;
      const tdRaw = String(banProfilRow?.td || '').trim();
      const tdParts = tdRaw ? tdRaw.split('-') : [];
      setDataBan((prev) => ({
        ...prev,
        id_ban: Number(banProfilRow?.id_ban || idBanTerpasang),
        kode_cabang: String(banProfilRow?.kode_cabang || prev?.kode_cabang || dataMT?.kode_cabang || actorKodeCabang || '').trim(),
        seri_ban: String(banProfilRow?.seri_ban || prev?.seri_ban || '').trim(),
        ukuran: String(banProfilRow?.ukuran || prev?.ukuran || '').trim(),
        merk: String(banProfilRow?.merk || prev?.merk || '').trim(),
        status: String(banProfilRow?.status || prev?.status || '').trim(),
        id_suplier: String(banProfilRow?.id_suplier || banProfilRow?.suplier || prev?.id_suplier || '').trim(),
        telapak: String(banProfilRow?.telapak || prev?.telapak || '').trim() || TELAPAK_DEFAULT,
        tanggal: formatYYYYMMDD(banProfilRow?.tanggal || prev?.tanggal || dataMT.tanggal),
        kmt: Number(banProfilRow?.kmt || prev?.kmt || 0),
        catatan_ban: String(banProfilRow?.catatan_ban || prev?.catatan_ban || '').trim(),
        place: `${dataMT.id_mt}#${idposisi}`,
      }));
      setTD({
        td1: Number(tdParts?.[0] || 0),
        td2: Number(tdParts?.[1] || 0),
        td3: Number(tdParts?.[2] || 0),
        td4: Number(tdParts?.[3] || 0),
      });
      return true;
    };

    if (isEditRecordDone && idBanTerpasang > 0) {
      (async () => {
        try {
          const { data } = await api.get(`${backendPort}/api/main/load_ban_profil_detail/${encodeURIComponent(idBanTerpasang)}`);
          if (cancelled) return;
          const ok = applyBanDetail(data);
          if (!ok) {
            showNotif('error', 'Data ban profil tidak ditemukan untuk mode edit done.');
          }
        } catch (err) {
          if (cancelled) return;
          console.error('Gagal load_ban_profil_detail:', err);
          const ok = applyBanDetail(null);
          if (!ok) {
            showNotif('error', err?.response?.data?.message || 'Gagal memuat data ban untuk mode edit done.');
          }
        }
      })();
      return () => { cancelled = true; };
    }

    if(daftarBan?.length > 0) {
      const rowsInitialMigrasi = daftarBan.filter(
        (x) => (x?.event?.startsWith('initial') || x?.event?.startsWith('migrasi'))
      );
      const thisBanById = rowsInitialMigrasi
        .filter((x) => Number(x?.id_ban || 0) === Number(idBanTerpasang || 0))
        .sort((a, b) => Number(b?.id_event || 0) - Number(a?.id_event || 0))[0];
      const thisBanByPosisi = rowsInitialMigrasi.find(
        (x) => x?.place?.split('#')[1] === idposisi
      );
      const thisBan = thisBanById || thisBanByPosisi || null;
      if(thisBan) {
        setDataBan({
          ...thisBan,
          telapak: String(thisBan?.telapak || '').trim() || TELAPAK_DEFAULT
        });
        
        const tdMap = {
          td1 : Number(thisBan.td?.split('-')[0] || 0),
          td2 : Number(thisBan.td?.split('-')[1] || 0),
          td3 : Number(thisBan.td?.split('-')[2] || 0),
          td4 : Number(thisBan.td?.split('-')[3] || 0), 
        };
        setTD(tdMap);
      } 
    } 
    return () => { cancelled = true; };
    },[idposisi, idBanTerpasang, dataMT.id_mt, dataMT.tanggal, actorNama, daftarBan, daftarKodeBan, TELAPAK_DEFAULT, isEditRecordDone, opsiBan])

  useEffect(() => {
    let cancelled = false;
    if (statusAksiBan !== 'edit' || idBanTerpasang <= 0) {
      setConstraintLoading(false);
      setEditConstraint({
        has_historical_event: false,
        lock_modal_except_merk_ukuran_catatan: false,
        disable_status: false,
        disable_supplier: false,
        disable_td: false,
        allow_td_bulk_sync: false,
      });
      return () => { cancelled = true; };
    }

    (async () => {
      try {
        setConstraintLoading(true);
        const res = await api.post(`${backendPort}/api/main/load_ban_edit_constraints`, {
          id_ban: idBanTerpasang
        });
        if (cancelled) return;
        setEditConstraint({
          has_historical_event: Boolean(res?.data?.has_historical_event),
          lock_modal_except_merk_ukuran_catatan: Boolean(res?.data?.lock_modal_except_merk_ukuran_catatan),
          disable_status: Boolean(res?.data?.disable_status),
          disable_supplier: Boolean(res?.data?.disable_supplier),
          disable_td: Boolean(res?.data?.disable_td),
          allow_td_bulk_sync: Boolean(res?.data?.allow_td_bulk_sync),
        });
      } catch (err) {
        if (cancelled) return;
        console.error(err);
        setEditConstraint({
          has_historical_event: false,
          lock_modal_except_merk_ukuran_catatan: false,
          disable_status: false,
          disable_supplier: false,
          disable_td: false,
          allow_td_bulk_sync: false,
        });
      } finally {
        if (!cancelled) setConstraintLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [statusAksiBan, idBanTerpasang]);

  const handleBan = async () => {
    const missingFields = [];
    const tdValues = [Number(td.td1), Number(td.td2), Number(td.td3), Number(td.td4)];

    if (!dataBan.merk?.trim()) missingFields.push("Merk Ban");
    if (!dataBan.seri_ban?.trim()) missingFields.push("Seri Ban");
    if (!dataBan.ukuran?.trim()) missingFields.push("Ukuran");
    if (!disableStatusField && !dataBan.status?.trim()) missingFields.push("Status Ban");
    if (!disableSupplierField && !dataBan.id_suplier?.trim()) missingFields.push("Suplier");
    if (tdValues.some((x) => !Number.isFinite(x) || x < 0 || x > 16)) {
      missingFields.push("Tire Depth (TD1-TD4, 1-16)");
    }
    if (missingFields.length > 0) {
      showNotif('error', `Data belum lengkap: ${missingFields.join(', ')}`);
      return;
    }

    //setLoading(true);
    try{
      setBisaSubmitEdit(false);

      const stringTD = `${td.td1}-${td.td2}-${td.td3}-${td.td4}`; 
      
      const kodeCabangSubmit = !isPusat
        ? actorKodeCabang
        : String(dataMT.kode_cabang || '').trim();
      const kirimAPI = {
        id_mt : dataMT.id_mt,
        kode_cabang : kodeCabangSubmit,
        id_ban : dataBan.id_ban ?? '', //id_ban Otomatis Sistem
        seri_ban  : statusAksiBan === 'baru'
          ? sanitizeSeriBanInput(dataBan.seri_ban)
          : (dataBan.seri_ban ?? ''),
        ukuran : dataBan.ukuran ?? '',
        merk : dataBan.merk ?? '',
        telapak: String(dataBan?.telapak || '').trim() || TELAPAK_DEFAULT,
        //event : dataBan.event,
        tanggal : dataBan.tanggal ?? '',
        kmt : Number(dataBan.kmt) ?? 0,
        td : stringTD,
        catatan_ban : dataBan.catatan_ban,
        place : dataBan.place,
        status : dataBan.status,
        reff : {},
        id_suplier : dataBan.id_suplier,
        kondisi_spakboard: isCadanganPosisi ? '' : kondisiSpakboard,
        user: dataBan.user,
        daftar_ban : {...daftarKodeBan, [idposisi] : dataBan.id_ban}
      };
      
      const res = await api.post(`${backendPort}/api/main/input_ban`,kirimAPI);
      const idBanFinal = res?.data?.id_ban ?? dataBan.id_ban;
      const daftarBanFinal = res?.data?.daftar_ban ?? { ...daftarKodeBan, [idposisi]: idBanFinal };
      if (typeof manualResyncGlobalOpsi === 'function') {
        await manualResyncGlobalOpsi({ force: true, requestGroup: 'page24-input-ban-sync' });
      }

      setDaftarBan((prev) => {
        const base = Array.isArray(prev) ? [...prev] : [];
        const updatedBan = {
          ...dataBan,
          id_ban: idBanFinal,
          td: stringTD,
          telapak: String(dataBan?.telapak || '').trim() || TELAPAK_DEFAULT,
          place: `${dataMT.id_mt}#${idposisi}`,
          event: dataBan.event || 'initial_otf',
          tanggal: formatYYYYMMDD(dataBan.tanggal),
        };
        const idx = base.findIndex((x) => (
          x?.place?.split('#')[1] === idposisi
          && (x?.event?.startsWith('initial') || x?.event?.startsWith('migrasi'))
        ));
        if (idx >= 0) {
          base[idx] = { ...base[idx], ...updatedBan };
          return base;
        }
        return [...base, updatedBan];
      });
      markSkipNextDaftarBanReload();
      setDaftarKodeBan(daftarBanFinal);
      setDataBan(prev => ({ ...prev, id_ban: idBanFinal }));
      setDataMTState((prev) => {
        const base = prev && typeof prev === 'object' ? prev : {};
        let parsed = {};
        try {
          const raw = base?.spakboard;
          parsed = typeof raw === 'string' ? (raw.trim() ? JSON.parse(raw) : {}) : (raw && typeof raw === 'object' ? raw : {});
        } catch {
          parsed = {};
        }
        if (isCadanganPosisi) {
          return base;
        }
        return {
          ...base,
          spakboard: JSON.stringify({
            ...parsed,
            [idposisi]: kondisiSpakboard || SPAKBOARD_DEFAULT
          })
        };
      });
      showNotif('success', 'Update Data Berhasil');
      close();
    }
    catch(e)
    {
      console.error(e);
      setBisaSubmitEdit(true);
      showNotif('error', e?.response?.data?.message || 'Update Data Gagal');
    }

  };
  const openAddTelapakModal = () => {
    if (!String(dataBan?.id_suplier || '').trim()) return;
    setNewTelapak('');
    setShowTelapakModal(true);
  };

  const handleSaveTelapakBaru = async () => {
    const supplierKey = String(dataBan?.id_suplier || '').trim();
    const candidate = String(newTelapak || '').trim();
    if (!supplierKey) {
      showNotif('error', 'Pilih suplier terlebih dahulu');
      return;
    }
    if (!candidate) {
      showNotif('error', 'Jenis telapak baru wajib diisi');
      return;
    }
    const existing = new Set(
      (telapakOptions || [])
        .filter((x) => x !== TELAPAK_ADD)
        .map((x) => String(x || '').trim().toLowerCase())
    );
    if (existing.has(candidate.toLowerCase())) {
      showNotif('error', 'Jenis telapak sudah ada pada daftar');
      return;
    }
    try {
      setSavingTelapak(true);
      const latestMaster = await manualResyncGlobalOpsi({ requestGroup: 'master-sync' });
      const latestRows = Array.isArray(latestMaster?.opsiSuplier) ? latestMaster.opsiSuplier : opsiSuplierRaw;
      const latestMap = buildTelapakBySuplier(latestRows);
      const latestSet = new Set((latestMap?.[supplierKey] || []).map((x) => String(x || '').trim().toLowerCase()));
      if (latestSet.has(candidate.toLowerCase())) {
        setTelapakBySuplier(latestMap);
        setDataBan((prev) => ({ ...prev, telapak: candidate }));
        setShowTelapakModal(false);
        setNewTelapak('');
        showNotif('success', 'Jenis telapak sudah tersedia dan telah disinkronkan');
        return;
      }
      await api.post(`${backendPort}/api/master/suplier_telapak_append`, {
        suplier: supplierKey,
        telapak: candidate
      });
      const syncedMaster = await manualResyncGlobalOpsi({ force: true, requestGroup: 'master-sync' });
      const syncedRows = Array.isArray(syncedMaster?.opsiSuplier) ? syncedMaster.opsiSuplier : latestRows;
      setTelapakBySuplier(buildTelapakBySuplier(syncedRows));
      setDataBan((prev) => ({ ...prev, telapak: candidate }));
      setShowTelapakModal(false);
      setNewTelapak('');
      showNotif('success', 'Jenis telapak berhasil ditambahkan');
    } catch (err) {
      console.error(err);
      showNotif('error', err?.response?.data?.message || 'Gagal menambahkan jenis telapak');
    } finally {
      setSavingTelapak(false);
    }
  };

  return (
    <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}
        ><div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="col-md-6 modal-content">
              <div className="card">
                <div className="d-flex justify-content-between align-items-center ml-3 me-3 mt-3">
                  <div className="fs-5 text-primary" style={{ fontWeight : "bold" }}>
                    {`${statusAksiBan === 'edit' ? 'Edit' : 'Input'} Profil Ban : ID-${dataBan?.id_ban || '-'}`}
                  </div>
                </div>
                <div className="card-body">
                  <div> 
                    {/**CABANG, ID DAN STATUS */}
                    <div className='row'>
                      
                      <div className='col-md-3 mb-3'>
                            <label>Cabang</label>
                            <select className="form-select"
                              disabled
                              value={kodeCabangAktif}
                              onChange={e => setDataBan(prev=>({...prev, kode_cabang : e.target.value}))}
                            >
                              <option value={kodeCabangAktif}>{namaCabangAktif || '-'}</option>
                              { 
                                actorKodeCabang === 'C-1' && opsiCabang.map((x,i) => (
                                  <option key={`${i}-${x.kode_cabang}`} value={x.kode_cabang}>
                                    {x.nama_cabang}
                                  </option>
                                ))
                              }
                            </select>  
                          </div>    
                      <div className="mb-3 col-md-2">
                            <label>ID Kendaraan</label>
                            <input
                              className="form-control"
                              value={dataMT.id_mt ?? ''}
                              disabled
                            />
                          </div>
                      <div className="col-md-3 mb-3" >
                            <label>No. Polisi</label>
                            <input
                              className="form-control"
                              value={dataMT.nopol}
                              disabled
                            />
                          </div>    
                      <div className="col-md-2 mb-3">
                            <label>Kode Posisi</label>
                            <input
                              className="form-control"
                              value={idposisi}
                              disabled
                            />
                          </div>  
                      <div className="col-md-2 mb-3">
                            <label>Status Aksi</label>
                            <input
                              className="form-control text-uppercase"
                              value={statusAksiBan}
                              disabled
                            />
                          </div>  
                      
                    </div>  
                    {/**MEREK*/}
                    <div className='row'>
                      <div className="col-md-3 mb-3">
                            <label>Merk Ban</label>
                            <select
                              className="form-select"
                              value={dataBan.merk}
                              onChange={(e) => setDataBan(prev=>({...prev, merk: e.target.value}))}
                            > <option key={'x'} value={''}>-Pilih Merk-</option>
                              { 
                                opsiMerkBan.map((x,i) => (<option key={i} value={x.nama_merk_ban}>{x.nama_merk_ban}</option>))
                              }
                            </select>
                          </div>

                      <div className="col-md-3 mb-3">
                            <label>Seri Ban</label>
                            <input
                              className="form-control"
                              type="text"
                              //inputMode="numeric"
                              //pattern="[0-9]*"
                              placeholder='Input No. Seri..'
                              value={dataBan.seri_ban}
                              onChange={(e) => {setDataBan(prev => ({ ...prev, seri_ban : sanitizeSeriBanInput(e.target.value) }))}}
                              disabled={statusAksiBan === 'edit' || lockModalExceptMerkUkuranCatatan}
                            />
                          </div>

                      <div className="col-md-3 mb-3">
                            
                          <label>Ukuran</label>
                          <select
                                  className="form-select"
                                  value={dataBan.ukuran}
                                  onChange={e => {
                                    setDataBan(prev=>({...prev, ukuran: e.target.value}));  
                                }}
                                ><option key={'x'} value={''}>-Pilih Ukuran-</option>
                                  { 
                                    opsiUkuran.map((x,i) => (
                                    <option key={i} value={x.ukuran}>{x.ukuran}</option>
                                  ))
                                  }
                          </select>
                        </div>
                      
                      <div className="col-md-3 mb-3">
                            
                          <label>Status</label>
                          <select
                            className="form-select"
                            value={dataBan.status}
                            onChange={e => {
                              setDataBan(prev=>({...prev, status: e.target.value}));  
                            }}
                            disabled={disableStatusField || disableStatusByDoneFlow}
                          ><option key={'x'} value={''}>-Pilih Status-</option>
                            {opsiStatus.map((x,i) => (<option key={i} value={x}>{x}</option>))}
                          </select>
                        </div>            

                    </div>

                    {/**KAPASITAS KATEGORI FORMASI CADANGAN KIR*/}      
                    <div className='row'>
                      
                      <div className="mb-3 col-md-6">
                        <label>Tire Depth Awal</label>
                        <div className='row'>
                            <div className='col-md-3'>
                            <input
                              className="form-control"
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              value={td.td1}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value) && value < 17) {
                                  setTD(prev => ({ ...prev, td1: value }));
                                  }
                              }}
                              disabled={disableTdField || disableTdByDoneFlow}
                            />
                            </div>
                            <div className='col-md-3'>
                            <input
                              className="form-control"
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              value={td.td2}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value) && value < 17) {
                                  setTD(prev => ({ ...prev, td2: value }));
                                  }
                              }}
                              disabled={disableTdField || disableTdByDoneFlow}
                            />
                            </div>
                            <div className='col-md-3'>
                            <input
                              className="form-control"
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              value={td.td3}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value) && value < 17) {
                                  setTD(prev => ({ ...prev, td3: value }));
                                  }
                              }}
                              disabled={disableTdField || disableTdByDoneFlow}
                            />
                            </div>
                            <div className='col-md-3'>
                            <input
                              className="form-control"
                              type="text"
                              inputMode="numeric"
                              pattern="[0-9]*"
                              value={td.td4}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value) && value < 17) {
                                  setTD(prev => ({ ...prev, td4: value }));
                                  }
                              }}
                              disabled={disableTdField || disableTdByDoneFlow}
                            />
                            </div>
                        </div>
                      </div>
                      
                      <div className="mb-3 col-md-3">
                        <label>Suplier</label>
                        <select
                              className="form-select"
                              value={dataBan.id_suplier}
                              onChange={(e) => setDataBan(prev=>({
                                ...prev,
                                id_suplier: e.target.value,
                                telapak: TELAPAK_DEFAULT
                              }))}
                              disabled={disableSupplierField}
                            >
                              <option value={''}>-Pilih Suplier-</option>
                              { 
                                opsiSuplierFinal.map((x,i) => (<option key={i} value={x}>{x}</option>))
                              }
                            </select>
                      </div>

                      <div className="mb-3 col-md-3">
                        <label>Jenis Telapak</label>
                        <select
                          className="form-select"
                          value={String(dataBan?.telapak || '').trim() || TELAPAK_DEFAULT}
                          disabled={lockModalExceptMerkUkuranCatatan || !String(dataBan?.id_suplier || '').trim()}
                          onChange={(e) => {
                            const value = String(e.target.value || '').trim();
                            if (value === TELAPAK_ADD) {
                              openAddTelapakModal();
                              return;
                            }
                            setDataBan((prev) => ({ ...prev, telapak: value || TELAPAK_DEFAULT }));
                          }}
                        >
                          {telapakOptions.map((opt, i) => (
                            <option key={`${opt}-${i}`} value={opt}>
                              {opt === TELAPAK_ADD ? 'Tambah Jenis Telapak' : opt}
                            </option>
                          ))}
                        </select>
                      </div>        
                    </div>
                    
                    {/**CATATAN*/} 
                    <div className='row d-flex justify-content-start'>
                      <div className="col-md-9 mb-3">
                        {showHistoricalWarning && (
                          <div className="text-muted fst-italic fw-light mb-1">
                            Sebagian data tidak dapat di edit karena sudah mengalami perubahan historical event.
                          </div>
                        )}
                        <label>Catatan Ban</label>
                        <textarea
                          className="form-control"
                          row={3}
                          maxLength={150}
                          placeholder='Tambahkan catatan ban bila diperlukan.'
                          value={dataBan.catatan_ban}
                          onChange={e => setDataBan(prev => ({
                            ...prev,
                            catatan_ban: e.target.value
                          }))}
                        />
                        <small className="text-muted">
                          {dataBan.catatan_ban?.length || 0}/150 karakter
                        </small>
                      </div>
                      <div className="col-md-3 mb-3">
                        <label>Kondisi Spakboard</label>
                        {isCadanganPosisi ? (
                          <input
                            className="form-control"
                            value="-"
                            disabled
                          />
                        ) : (
                          <select
                            className="form-select"
                            value={kondisiSpakboard}
                            onChange={(e) => setKondisiSpakboard(String(e.target.value || '').trim() || SPAKBOARD_DEFAULT)}
                          >
                            {SPAKBOARD_OPTIONS.map((opt) => (
                              <option key={opt} value={opt}>{opt}</option>
                            ))}
                          </select>
                        )}
                      </div>
                    </div>
                    

                    {/**BUTTON*/}          
                    <div className='d-flex justify-content-center'>
                      <div children='col-md-8 mt-5'>
                          
                        <div className='row d-flex justify-content-center'>
                            <button className="btn btn-secondary me-2 w-auto"
                              type="button"
                              onClick={() => {close()}}
                            >Tutup</button>

                            <button className="btn btn-primary me-2 w-auto"
                            type="button"
                            disabled = {!bisaSubmitEdit}
                            onClick={handleBan}
                            >Simpan dan Tutup</button>
                          </div>                 
                     
                      </div>
                    </div>
                          
                  </div>          
                </div>     
              </div>                   
        </div>
        </div>
        {showTelapakModal && (
          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.3)' }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h6 className="modal-title">Tambah Jenis Telapak</h6>
                  <button type="button" className="btn-close" onClick={() => setShowTelapakModal(false)} />
                </div>
                <div className="modal-body">
                  <label>Jenis Telapak Baru</label>
                  <input
                    className="form-control"
                    value={newTelapak}
                    maxLength={60}
                    onChange={(e) => setNewTelapak(String(e.target.value || '').replaceAll('#', '').replace(/\s+/g, ''))}
                    placeholder="Input jenis telapak baru"
                  />
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowTelapakModal(false)}>Batal</button>
                  <button type="button" className="btn btn-primary" disabled={savingTelapak} onClick={handleSaveTelapakBaru}>
                    Simpan
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
    </div>
  )


}

function StatRow ({ label, value, terpasang, onClick }) {
  return (
    <div className='border-success col-md-6 mb-2'>
    <div className="flex justify-between items-center px-3 py-2 rounded" style={{background: "#e7f5ff"}}>
      <span className="text-gray-900">{label}</span>

      <span onClick={onClick} style={{ cursor: 'pointer' }}
        className={`px-2 py-0.5 rounded text-xs font-medium
          ${terpasang ? 'bg-green-200 text-green-800' : 'bg-red-300 text-red-800'}
        `}
      >
        {value}
      </span>
    </div>
    </div>
  );
}
